import { parseGettingYourOrderData } from '../../global/store-locator/availability';
import {
  clearVariantAvailabilityCache,
  enrichWithOnlineFulfillmentStock,
  enrichWithStorefrontAvailability,
} from '../../global/store-locator/variant-availability';
import { renderGettingYourOrder } from './ui';

let documentListenersBound = false;

async function refreshAllBlocks() {
  const blocks = [...document.querySelectorAll('[data-getting-your-order]')];
  await Promise.all(blocks.map((block) => refreshBlock(block)));
}

function getLiveBlock(block) {
  const sectionId = block.dataset.sectionId;
  if (!sectionId) return block.isConnected ? block : null;

  const liveBlock = document.querySelector(
    `[data-getting-your-order][data-section-id="${CSS.escape(sectionId)}"]`
  );

  return liveBlock ?? (block.isConnected ? block : null);
}

function renderLive(block, variantData) {
  const liveBlock = getLiveBlock(block);
  if (!liveBlock) return null;
  renderGettingYourOrder(liveBlock, variantData);
  return liveBlock;
}

async function refreshBlock(block) {
  const baseVariantData = parseGettingYourOrderData(block);

  renderGettingYourOrder(block, {
    ...baseVariantData,
    onlineQuantity: null,
    onlineStockStatus: 'pending',
  });

  if (!baseVariantData?.variantId) {
    return;
  }

  const withStorefront = await enrichWithStorefrontAvailability(baseVariantData);
  if (!renderLive(block, withStorefront)) return;

  const withOnlineStock = await enrichWithOnlineFulfillmentStock(withStorefront);
  renderLive(block, withOnlineStock);
}

function bindDocumentListeners() {
  if (documentListenersBound) return;

  documentListenersBound = true;

  document.addEventListener('store-locator:shop-changed', refreshAllBlocks);
  document.addEventListener('store-locator:delivery-changed', refreshAllBlocks);
  document.addEventListener('store-locator:delivery-cleared', refreshAllBlocks);
  document.addEventListener('on:variant:change', (event) => {
    const variantId = event.detail?.variant?.id;

    if (variantId) {
      clearVariantAvailabilityCache(variantId);
    }

    requestAnimationFrame(refreshAllBlocks);
  });
}

export default function gettingYourOrder() {
  bindDocumentListeners();
  document.querySelectorAll('[data-getting-your-order]').forEach((block) => {
    refreshBlock(block);
  });
}
